export const buryAreaCoords = [
  [53.5391, -2.238077],
  [53.558983, -2.237097],
  [53.563266, -2.248427],
  [53.571421, -2.243964],
  [53.585486, -2.264906],
  [53.579372, -2.271773],
  [53.590377, -2.272803],
  [53.599343, -2.246367],
  [53.606677, -2.251517],
  [53.619956, -2.283331],
  [53.666838, -2.300078],
  [53.654937, -2.315442],
  [53.655039, -2.333467],
  [53.659362, -2.355439],
  [53.664397, -2.355783],
  [53.66694, -2.37106],
  [53.655904, -2.362477],
  [53.644966, -2.366855],
  [53.642117, -2.372434],
  [53.631888, -2.371232],
  [53.630768, -2.378957],
  [53.625576, -2.383163],
  [53.610354, -2.362821],
  [53.59589, -2.368228],
  [53.59319, -2.376725],
  [53.570566, -2.373549],
  [53.56851, -2.361023],
  [53.556393, -2.355827],
  [53.553878, -2.373148],
  [53.545931, -2.341296],
  [53.533693, -2.337928],
  [53.527287, -2.310213],
  [53.51716, -2.302034],
  [53.512354, -2.290582],
  [53.518362, -2.257094],
  [53.528888, -2.247279],
  [53.524598, -2.264119],
  [53.539126, -2.267102],
  [53.545016, -2.252186],
  [53.539355, -2.237752],
];
